import type { ScanMode } from '../../app/scanModeContext'
import styles from './SegmentedToggle.module.css'

interface SegmentedToggleProps {
  mode: ScanMode
  onChange: (mode: ScanMode) => void
}

/**
 * Add / remove mode. The colour is the load-bearing part: green for add, red for remove,
 * and in remove mode the whole screen gets a red inset border too, because an operator
 * glancing down must not have to read a label to know which way the scan will go.
 */
export function SegmentedToggle({ mode, onChange }: SegmentedToggleProps) {
  return (
    <div className={styles.group} role="group" aria-label="حالت اسکن">
      <button
        type="button"
        className={`${styles.segment} ${mode === 'add' ? styles.activeAdd : ''}`}
        aria-pressed={mode === 'add'}
        onClick={() => onChange('add')}
      >
        حالت افزودن
      </button>
      <button
        type="button"
        className={`${styles.segment} ${mode === 'remove' ? styles.activeRemove : ''}`}
        aria-pressed={mode === 'remove'}
        onClick={() => onChange('remove')}
      >
        حالت حذف
      </button>
    </div>
  )
}
